module.exports = __webpack_public_path__ + "img/member_default.23a0b9d2.png";